const SDK_VERSION = '7.91.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
